// csvダウンロード用のjsonデータ取得
export const getCsvJson = (items, data) => {
  let json = {};
  for (var key in items) {
    json[items[key]] = data[key];
  }

  return json;
};
